import {
  AbstractControlOptions,
  AsyncValidatorFn,
  ValidatorFn,
  UntypedFormControl,
  UntypedFormArray,
  UntypedFormGroup,
  AbstractControl,
} from '@angular/forms';

/**
 * Model what the `FormBuilder.control` method receives.
 */
export type ValidatorOrOpts = AbstractControlOptions | ValidatorFn[] | ValidatorFn;
/**
 * Model what the `FormBuilder.control` method receives here.
 */
export type AsyncValidator = AsyncValidatorFn | AsyncValidatorFn[];
/**
 * Model what the `FormBuilder._createControl` method receives.
 */
export type ControlConfig<V> =
  | UntypedFormControl
  | UntypedFormGroup
  | UntypedFormArray
  | [V | { value: V; disabled?: boolean }, ValidatorOrOpts?, AsyncValidator?];
/**
 * Model what the `FormBuilder.group` method accepts as its `controlsConfig`
 * parameter.
 */
export type FormModel<T> = {
  [P in keyof T]: ControlConfig<T[P]>;
};

export class FormGroupModel<T> extends UntypedFormGroup {
  controls: {
    [key: string]: AbstractControl;
  };
  value: T;
}
